'use client';

import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslations } from 'next-intl';
import { Drawer, DrawerClose, DrawerContent } from '@/components/ui/drawer';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import IconFont from '@/components/ui/iconFont';

interface ModalWarnProps {
  imgUrl?: string;
  title?: string;
  imgWidth?: number;
  imgHeight?: number;
  onOk?: () => void;
}

const ModalWarn = NiceModal.create((props: ModalWarnProps) => {
  const { title = '', imgUrl, imgWidth = 100, imgHeight = 100 } = props;
  const t = useTranslations('auth');
  const modal = useModal();

  const handleOk = () => {
    modal.hide();
    modal.remove();
  };

  return (
    <Drawer open={modal.visible} onOpenChange={(open) => !open && modal.hide()}>
      <DrawerContent>
        <DrawerClose asChild>
          <div className="absolute top-[25px] right-[20px]">
            <IconFont name="close" size={13} color="#a9b5cb" />
          </div>
        </DrawerClose>
        <div className='w-full flex flex-col justify-between items-center min-h-[121px] px-[12px] pt-12 pb-[20px] bg-surface rounded-t-[10px]'>
          <Image className='rounded-[10px]' src={imgUrl || ''} alt="warn" width={imgWidth} height={imgHeight} />
          <div className="text-tertiary text-ss leading-[15px] font-medium pt-[12px]">
            {title}
          </div>
          <Button onClick={handleOk} variant="primary" className='w-full mt-[35px]'>{t('errors.ok')}</Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
});

export default ModalWarn;